module.exports = {"TXTWCL_Resend_code":{"id":"TXTWCL_Resend_code","defaultMessage":"コードを再送信","track":"Resend code"}}